export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 110,
    slots: { default: 'opt', },
  },
  {
    title: that.$l('table_label_shippingMarkType') || '唛头类型',
    field: 'v_shippingMarkType',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shippingMarkContext') || '唛头内容',
    align: 'center',
    minWidth: 130,
    slots: { default: 'shippingMarkContext', },
  },
  {
    title: that.$l('form_label_shippingMarkTextEn') || '唛头英文名称',
    field: 'nameEn',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_destinationPort') || '关联目的港口',
    field: 'v_destinationPort',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '关联客户',
    field: 'custName',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
